/* eslint-disable @typescript-eslint/no-unused-vars */
import { PageContent } from "components/PageContent";
import { ISectionMenuItem } from "components/PageTopNav";
import { useWebStoreContext } from "contexts";
import { IShopSection } from "contexts/WebStoreProvider/types";
import { useAppSelector } from "hooks";
import { isEqualWith } from "lodash";
import { createRef, useEffect, useRef, useState } from "react";
import { selectShopSectionsState } from "redux/slices/shop-sections";
import { ShopContext } from ".";
import FeaturedDeals from "./lib/FeaturedDeals";
import { LimitedDealsSection } from "./lib/LimitedDealsSection";
import SingleItems from "./lib/SingleItems";
import PageTopNavV2 from "components/PageTopNavV2";
import { offersApi } from "redux/apis";
import { FAQ } from "./lib/FAQ";
import HeaderBanner from "./lib/HeaderBanner";
import { useTutorial } from "./hooks/useTutorial";
import NoSessionLayout from "components/NoSessionLayout";

const StoreFrontV2 = () => {
	const { shopSections } = useAppSelector(selectShopSectionsState);
	const [sectionMenuData, setSectionMenuData] = useState<ISectionMenuItem[]>(
		[]
	);
	const { authToken } = useWebStoreContext();
	const [mainShopSections, setShopSections] = useState<IShopSection[]>([]);

	const { data: featuredDealsData } =
		offersApi.endpoints.getOffers.useQueryState({
			offerType: "featured",
			isAuthenticated: !!authToken?.value
		});

	useTutorial({ sectionMenuData });

	useEffect(() => {
		window?.scrollTo(0, 0);
	}, []);

	//Prevent rerendering when processing storeRaw
	useEffect(() => {
		if (!shopSections?.mainShopSections) {
			return;
		}
		if (isEqualWith(shopSections?.mainShopSections, mainShopSections)) {
			return;
		}
		setShopSections(shopSections?.mainShopSections);
	}, [shopSections?.mainShopSections]);

	const sectionRefs = useRef<{ [key: number]: React.RefObject<HTMLElement> }>(
		{}
	);

	useEffect(() => {
		const newSectionMenuData = mainShopSections.map((data, index) => {
			const {
				name,
				title: text,
				iconImageUrl: icon,
				cardBackgroundImageUrl,
				startTime,
				endTime
			} = data;

			const sectionRef = sectionRefs.current[index] || createRef();
			sectionRefs.current[index] = sectionRef;

			return {
				name,
				text,
				icon,
				sectionRef,
				analytics_source: "store",
				cardBackgroundImageUrl,
				startTime,
				endTime
			};
		});

		setSectionMenuData(newSectionMenuData);
	}, [mainShopSections, featuredDealsData]);

	return (
		<ShopContext.Provider value={{ sectionMenuData }}>
			{!authToken?.value ? (
				<NoSessionLayout sectionMenuData={sectionMenuData} />
			) : (
				<div
					style={{
						position: "relative"
					}}
				>
					<HeaderBanner />
					<PageTopNavV2
						sectionMenuData={sectionMenuData}
						hasSectionBanner={true}
					/>
					<PageContent
						source={"store_page"}
						sxContainer={{
							paddingBottom: "0 !important",
							minHeight: "unset"
						}}
					>
						<FeaturedDeals />
						<LimitedDealsSection />
						<SingleItems />
					</PageContent>
					<PageContent
						source={"store_page"}
						sxContent={{
							minWidth: "100%"
						}}
						enableBackToTop={true}
					>
						<FAQ />
					</PageContent>
				</div>
			)}
		</ShopContext.Provider>
	);
};

export default StoreFrontV2;
